import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { facilityAction, TherapistAction } from 'src/redux/actions/constant';
import facilityService from '../../../services/apiServices/facilityService';

const {
  SWITCH_FACILITY_REQUEST,
  SWITCH_FACILITY_SUCCESS,
  SWITCH_FACILITY_FAILURE,
  SWITCH_FACILITY_LOADER,
} = facilityAction;

const { GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST, GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_RESET } =
  TherapistAction;

function* updateFacilitiesData(action: any): SagaReturnType<any> {
  try {
    yield put({ type: SWITCH_FACILITY_LOADER });
    const response = yield call(facilityService.swicthFacility, action.uuid);
    if (response?.status === 200) {
      yield put({ type: SWITCH_FACILITY_SUCCESS, payload: response });
      // New facility context: clear the previous flag so it starts unresolved
      // (hidden) and can't paint the old facility's value while the new one loads.
      yield put({ type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_RESET });
      yield put({ type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: SWITCH_FACILITY_FAILURE, payload: error });
  }
}

function* updateFacilityDropDownSaga() {
  yield takeEvery(SWITCH_FACILITY_REQUEST, updateFacilitiesData);
}

export default updateFacilityDropDownSaga;
